import { lazy } from 'react';

const CreditAssessment = lazy(() =>
  import('../pages/CreditAssessment/index.js').then((module) => ({
    default: module.CreditAssessment,
  })),
);

const creditAssessmentRoute = {
  public: [],
  auth: [
    {
      name: 'credit_assessment',
      path: '/customers/credit-assessment',
      component: CreditAssessment,
    },
  ],
};

export default creditAssessmentRoute;
